<script setup lang="ts">
false && /*#__PURE__*/ defineI18nRoute({
  paths: {
    en: '/news',
    sk: '/novinky',
  },
})

const { t } = useI18n()

useSeoMeta({
  description: t('pages.news.meta.description'),
})
</script>

<template>
  <NuxtPage />
</template>
